const MAP = {
  Reserved: "bg-blue-500/10 text-blue-400 border-blue-500/25",
  Fabricating: "bg-yellow-500/10 text-yellow-400 border-yellow-500/25",
  Installed: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
};

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-3 py-1 text-[10px] font-medium uppercase tracking-[0.16em] ${
      MAP[status] || MAP.Reserved
    }`}
  >
    {status}
  </span>
);
